import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/WiFi/ac-mesh-pro@2x.jpg";
import v3Image from "../../assets/Flagship/acMeshProfessional.jpg";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifi-outdoor";
import {
  antennaType,
  connectedDevices,
  extendedRangeMode6Ghz,
  externalAntennaSupport,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const acMeshProfessional: Product = {
  id: "acMeshProfessional",
  productTitle: "AC Mesh Pro",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/unifi-ac-mesh-pro-ap`,
  ],
  storePathParts: {
    productSlug: "unifi-ac-mesh-pro-ap",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "UAP-AC-M-PRO",
  description: "acMeshProfessional.description",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '343.2 x 181.2 x 60.2 mm\n(13.5 x 7.1 x 2.4")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "acMeshProfessional.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "185 m² (2,000 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "250+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "GbE" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX4" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
};
